import { InjectionToken } from '@angular/core';

export const MDB_LIGHTBOX = new InjectionToken('MDB_LIGHTBOX');
